import { MealPlanForUserFragment, MealPlanStatus } from 'src/gqlReactTypings.generated.d';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { createSelectors } from '../create-selectors';

interface State {
  mealPlan?: MealPlanForUserFragment;
  userHasActiveMealPlan: boolean;
  mealPlanDataLoaded: boolean;
}

interface Actions {
  setMealPlanForUser: (mealPlanForUser?: MealPlanForUserFragment) => void;
  getMealPlanForUser: () => MealPlanForUserFragment | undefined;

  // Convenience getters that read from the mealPlan fragment (undefined when no active plan)
  getMealPlanType: () => MealPlanForUserFragment['mealPlanType'] | undefined;
  getNextDeliveryDate: () => string | undefined;
  getIsReusablePackaging: () => boolean | undefined;
  getMealPlanPauseEndDate: () => string | null | undefined;
}

// Initialize a default state
export const INITIAL_STATE: State = {
  mealPlan: undefined,
  userHasActiveMealPlan: false,
  mealPlanDataLoaded: false,
};

export const useMealPlanForUserStore = create(
  immer<State & Actions>((set, get) => ({
    ...INITIAL_STATE,
    setMealPlanForUser: (mealPlan?: MealPlanForUserFragment) => {
      set({ mealPlan, userHasActiveMealPlan: mealPlan?.status === MealPlanStatus.Active, mealPlanDataLoaded: true });
    },
    getMealPlanForUser: () => get()?.mealPlan,

    getMealPlanType: () => get().mealPlan?.mealPlanType,
    getIsReusablePackaging: () => get().mealPlan?.isReusablePackagingPlan,
    getNextDeliveryDate: () => get().mealPlan?.nextDeliveryDate,
    getMealPlanPauseEndDate: () => get().mealPlan?.pauseEndDate,
  }))
);

export const useMealPlanForUserStoreSelectors = createSelectors(useMealPlanForUserStore);
